class SourceTracker {
  constructor() {
    this.sourceData = {};
    this.init();
  }

  init() {
    // Get UTM parameters
    const urlParams = new URLSearchParams(window.location.search);
    this.sourceData = {
      utm_source: urlParams.get('utm_source'),
      utm_medium: urlParams.get('utm_medium'),
      utm_campaign: urlParams.get('utm_campaign'),
      utm_term: urlParams.get('utm_term'),
      utm_content: urlParams.get('utm_content'),
      referrer: document.referrer,
      landing_page: window.location.pathname,
      timestamp: new Date().toISOString(),
    };

    // Store in localStorage for persistence
    this.storeSourceData();

    // Log the source data (you can replace this with your analytics tracking)
  }

  storeSourceData() {
    // Only store if we have some meaningful data
    if (this.sourceData.utm_source || this.sourceData.referrer) {
      localStorage.setItem('user_source_data', JSON.stringify(this.sourceData));
    }
  }

  getSourceData() {
    return this.sourceData;
  }
}

// Initialize the tracker
const sourceTracker = new SourceTracker();
